function finiteNumber(value) {
  if (value == null || value === '') return null;
  const n = Number(value);
  return Number.isFinite(n) ? n : null;
}

/**
 * P&L to show when a position closes.
 * Prefer an explicit non-zero realized figure on the close event, then the
 * close event's unrealized P&L, then the last open snapshot (the number that
 * was on screen before the flat update). A zero on the delete event is not
 * the trade result when the open position already had a P&L.
 */
export function resolveClosedPositionPnl(priorPosition, closeEvent) {
  const realized = finiteNumber(
    closeEvent?.RealizedPnL ?? closeEvent?.RealizedProfitLoss ?? priorPosition?.RealizedPnL
  );
  if (realized != null && realized !== 0) return realized;

  const eventOpen = finiteNumber(closeEvent?.UnrealizedProfitLoss);
  const priorOpen = finiteNumber(priorPosition?.UnrealizedProfitLoss);

  if (eventOpen != null && eventOpen !== 0) return eventOpen;
  if (priorOpen != null) return priorOpen;
  if (realized != null) return realized;
  if (eventOpen != null) return eventOpen;
  return null;
}
